import { SignUpSteps } from "@/components/auth/SignUpSteps";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { LanguageSwitcher } from "@/components/ui/language-switcher";
import { useTranslation } from "react-i18next";

const SignUp = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const sharedFeatures = [
    t("pricing.features.direct_payment_link"),
    t("pricing.features.custom_templates"),
    t("pricing.features.automated_scheduling"),
    t("pricing.features.payment_tracker"),
    t("pricing.features.bulk_scheduling"),
    t("pricing.features.branded_invoice"),
  ];

  return (
    <div className="auth-page min-h-screen pb-[100px] flex flex-col bg-[radial-gradient(at_75%_70%,#8791F3_15%,#A7DCD8_70%,#F1F6F5_80%)]">
      <Button
        variant="ghost"
        className="absolute top-4 left-4 text-[#34375B] bg-[#5CC2BB] hover:text-[#F1F6F5] hover:bg-[#8791F3] hover:shadow-[4px_4px_0px_0px_#34375B] hover:-translate-x-1 hover:-translate-y-1 transition-all duration-200"
        onClick={() => navigate("/")}
      >
        <ArrowLeft />
        {t("hero.back")}
      </Button>

      <div className="absolute top-4 right-4">
        <LanguageSwitcher />
      </div>

      <div className="container mx-auto px-4 sm:px-6 pt-20">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {/* Left Column - Sign Up Form */}
          <div className="w-full">
            <div className="p-4 sm:p-6 rounded-lg shadow-lg bg-[#F1F6F5] border-2 border-[#34375B]">
              <SignUpSteps />
            </div>
          </div>

          {/* Right Column - Features */}
          <div className="w-full flex flex-col items-center md:items-start justify-start">
            <img
              src="/landing/undraw_time-management_fedt.svg"
              alt="Features illustration"
              className="hidden md:block w-3/5 h-2/5 max-w-xs mx-auto mb-8"
            />
            <div className="space-y-4 w-full md:ml-28 pt-6 flex flex-col items-center md:items-start">
              <h3 className="text-2xl font-bold text-[#34375B] mb-6 text-center md:text-left">
                {t("auth.included_features")}
              </h3>
              <ul className="space-y-4">
                {sharedFeatures.map((feature) => (
                  <li key={feature} className="flex items-center gap-3 text-[#34375B]">
                    <Check className="h-8 w-6 text-[#5CC2BB] stroke-20" />
                    <span className="text-lg font-semibold">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
